import { useTranslations } from 'featureSliced/shared/hooks/useTranslations'
import { useMySelector } from 'featureSliced/shared/hooks/useMySelector'
import { useOpenModal } from 'featureSliced/shared/hooks/useOpenModal'
import { Note } from './Note'

export type OpenNoteType = (
  productId: number,
  categoryId: number,
  onUpdate?: (value: { [key: number]: string }) => void,
  isUpdatesAvailable?: boolean
) => void

export const useOpenNote = (): OpenNoteType => {
  const t = useTranslations()
  const openModal = useOpenModal()
  const { notesAvailable } = useMySelector((state) => state.app.menu)

  const openNote = (
    productId: number,
    categoryId: number,
    onUpdate: any,
    isUpdatesAvailable = true
  ) => {
    if (notesAvailable === 1) {
      openModal({
        id: 'PRODUCT_NOTE',
        title: t('products.note'),
        components: [
          () => (
            <Note
              productId={productId}
              categoryId={categoryId}
              onUpdate={onUpdate}
              isUpdatesAvailable={isUpdatesAvailable}
            />
          ),
        ],
      })
    }
  }

  return openNote
}
